import React from 'react';
import Priority from './Priority';
import Menu from '../Menu/Menu';
import Icons from '../../Containers/Icons';

let VisualNew = (props) => {

  let {tab, vis, img, url, setPriority, setNote, locale, date, saveCard} = props;
  if (tab) {
    return (
      <div id="newCard">
        <div id="topNewCard">
          <span className="tabName">{tab.name}</span>
          <span className="arrow white"><Icons name="arrowThin" /></span>
          <span className="tabFullName">{tab.fullname}</span>
          <span className="arrow white"><Icons name="arrowThin" /></span>
          <span className="visName">{vis.name}</span>
        </div>
        <div id="CardInner">
          <div className="visualOuter">
            <img src={url + img} alt="Visuales"/>
          </div>
          <div className="notesVis">
            <h3>Notas</h3>
            <textarea onChange={(note) => setNote(note)}/>
          </div>
          <Priority setPriority={setPriority} />
        </div>
        <Menu type="addcard" date={date} locale={locale} funct={saveCard}/>
      </div>
    )
  } else {
    return(
      <div>
      </div>
    )
  }
}
export default VisualNew;


// WEBPACK FOOTER //
// ./src/Components/AddCards/VisualNew.js